<template>
<form @submit.prevent>
    <h1>Get Started</h1>

    <label for="name">Name</label>
    <input v-model.trim="signupForm.name" type="text" placeholder="Savvy Apps" id="name" /><br>

    <label for="title">Title</label>
    <input v-model.trim="signupForm.title" type="text" placeholder="Company" id="title" /><br>

    <label for="email2">Email</label>
    <input v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email2" /><br>

    <label for="password2">Password</label>
    <input v-model.trim="signupForm.password" type="password" placeholder="min 6 characters" id="password2" />

   
    <div class="extras">
        <a>Back to Log In</a>
    </div>
</form>
</template>

<script>
export default {
data() {
    return {
        loginForm: {
            email: '',
            password: ''
        },
        signupForm: {
            name: '',
            title: '',
            email: '',
            password: ''
        }
    }
}
}
</script>

<style>

</style>
